module.exports = __webpack_public_path__ + "img/swap_dark_icon.5115082a.svg";